import { lazy } from 'react';
import PATH from 'routes/paths';

const InternalRequestSettings = lazy(() =>
  import('containers/project/internalRequest/settings/InternalRequestSettings')
);

export const INTERNAL_REQUEST_SETTINGS = {
  component: InternalRequestSettings,
  path: PATH.SETTINGS.INTERNAL_REQUESTS,
  exact: true,
  isProtected: true,
};

export default [INTERNAL_REQUEST_SETTINGS];
